import {
  DOCKERFILE_PATH_PROPERTY_NAME,
  DOCKERFILE_SOURCE_PROPERTY_NAME,
  DOCKER_IMAGE_PROPERTY_NAME,
} from './JobStepRunInDocker.consts'

export function getDockerValues(step: Record<string, string>) {
  return {
    dockerImageValue: step[DOCKER_IMAGE_PROPERTY_NAME] as string | undefined,
    dockerfileSourceValue: step[DOCKERFILE_SOURCE_PROPERTY_NAME] as string | undefined,
    dockerfilePathValue: step[DOCKERFILE_PATH_PROPERTY_NAME] as string | undefined,
  }
}
